export const codResponseDelay = '40010021';
